var map = {
	"./decidim/avatar-multiuser.png": 39701,
	"./decidim/brands/facebook.svg": 17649,
	"./decidim/brands/google.svg": 72,
	"./decidim/brands/twitter-x.svg": 87437,
	"./decidim/cc-badge.png": 93779,
	"./decidim/decidim-logo.svg": 24343,
	"./decidim/default-avatar.svg": 32507,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 14513,
	"./decidim/icons.svg": 1642,
	"./decidim/pattern.png": 7545,
	"./decidim/placeholder-card-g.svg": 89750,
	"./decidim/placeholder-card-l.svg": 41437,
	"./decidim/placeholder.jpg": 22908,
	"./decidim/remixicon.symbol.svg": 61038,
	"./decidim/vendor/social-share-button/douban.svg": 93169,
	"./decidim/vendor/social-share-button/email.svg": 24402,
	"./decidim/vendor/social-share-button/facebook.svg": 32666,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 93238,
	"./decidim/vendor/social-share-button/hacker_news.svg": 87906,
	"./decidim/vendor/social-share-button/linkedin.svg": 27808,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 53849,
	"./decidim/vendor/social-share-button/pinterest.svg": 35276,
	"./decidim/vendor/social-share-button/reddit.svg": 75654,
	"./decidim/vendor/social-share-button/telegram.svg": 67991,
	"./decidim/vendor/social-share-button/tumblr.svg": 85268,
	"./decidim/vendor/social-share-button/twitter.svg": 82823,
	"./decidim/vendor/social-share-button/vkontakte.svg": 6549,
	"./decidim/vendor/social-share-button/wechat.svg": 79128,
	"./decidim/vendor/social-share-button/whatsapp.svg": 64920,
	"./decidim/vendor/social-share-button/x.svg": 89522,
	"./decidim/vendor/social-share-button/xing.svg": 81686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3416;